import { logger } from '@fiverr-private/obs';
import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import { StoreWithSetter } from '../types';

type MixpanelRecord<TKey extends MIXPANEL_EVENT_PROPERTIES, TValue> = Record<TKey, TValue>;

interface Config {
    disableErrorLogging: boolean;
}

export class SimpleStore<TKey extends MIXPANEL_EVENT_PROPERTIES, TValue>
    implements StoreWithSetter<TValue, MixpanelRecord<TKey, TValue> | null>
{
    private _value?: MixpanelRecord<TKey, TValue>;

    private _rawValue?: TValue;

    private _disableErrorLogging = false;

    constructor(
        private key: TKey,
        { disableErrorLogging = false }: Config = {
            disableErrorLogging: false,
        }
    ) {
        this._disableErrorLogging = disableErrorLogging;
    }

    public getRawData = () => this._rawValue;

    public getData = () => {
        if (this._value === undefined && !this._disableErrorLogging) {
            const error = new Error(`No ${this.key} was set`);
            logger.info(error);
        }

        return this._value || null;
    };

    public setData = (value: TValue) => {
        this._value = {
            [this.key]: value,
        } as MixpanelRecord<TKey, TValue>;
    };
}
